export default __webpack_public_path__ + "static/media/Book_Hex.5561c4af.svg";